export default {
  promotions: {
    accessIf: {
      roles: ['admin', 'customer_solutions', 'retail_manager', 'marketing', 'ops_admin']
    }
  },
  giftCards: {
    accessIf: {
      roles: ['admin', 'customer_solutions', 'ops_admin']
    }
  },
  stockManagement: {},
  createStockInLocation: {
    accessIfNot: {
      roles: ['sales']
    }
  },
  inventory: {},
  convertToFrame: {},
  consumables: {
    accessIfNot: {
      roles: []
    }
  },
  anonymiseUser: {
    accessIf: {
      roles: ['customer_solutions', 'admin', 'ops_admin']
    }
  },
  taskExecutionMenu: {
    accessIf: {
      roles: ['customer_solutions', 'admin', 'ops_admin']
    }
  },
  customerTags: {
    accessIf: {
      roles: ['admin']
    }
  },
  customerSummary: {
    accessIf: {
      roles: ['admin']
    }
  },
  appointmentSummary: {
    accessIf: {}
  }
}
